// eslint-disable-next-line import/extensions
import event from './event'
import report from './report'

export default [...event, ...report]
